import React, { useContext } from 'react';
import { FormSectionGlobal as FormSection } from '@fitinsur/components';
import FormContainer from "components/FormContainer";
import Label from 'components/Form/Label';
import Row from 'components/Grid/Row';
import Col from 'components/Grid/Col';
import { TaxCalculationSection } from '../index';

import IMask from 'imask';
import MasksHelper from 'utils/src/masks';
import { GlobalAuthContext } from 'store/context';

/**
 * Calcula a quantidade de questions não visíveis, sendo útil para o cálculo do tamanho dos elementos <div/> do componente TaxTotals
 * 
 * @param {array} groupQuestions Grupo de questions
 * @returns Quantidade de question não visíveis
 */
function countInvisibleQuestions(groupQuestions) {
  let count = 0;

  groupQuestions.forEach(question => {
    if(!question.visibleQuestion) count++;
  });

  return count;
}

/**
 * Função para formatar um valor inteiro com base na região desejada
 * 
 * @param {integer} value Valor a ser formatado
 * @param {*} region Região que será utilizada como base para a formatção
 * @returns Valor formatado
 */
function applyMaskCurrency(value, region) {
  const maskHelper = new MasksHelper();

  let maskCurrency = maskHelper.getMask("currency", region, 2, null, 999999999999999, -999999999999999);
  let mask = IMask.createMask(maskCurrency);
  mask.resolve(`${value}`);
  return mask.value;
}

function TaxTotals({ tax }) {
  const authContext = useContext(GlobalAuthContext);
  const invisibleQuestions = countInvisibleQuestions(tax.groupedQuestions[0])
  
  const labelWidth =  100 / (tax.groupedQuestions[0].length - invisibleQuestions);
  return (   
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Label style={{ width: `${labelWidth}%`}}>{applyMaskCurrency(Number(tax.dpTaxGrandTotal)?.toFixed(2), authContext.region)}</Label>
      <Label style={{ width: `${labelWidth}%`}}>{applyMaskCurrency(Number(tax.apTaxGrandTotal)?.toFixed(2), authContext.region)}</Label>
      <Label style={{ width: `${labelWidth}%`}}>{applyMaskCurrency(Number(tax.totalTaxGrandTotal)?.toFixed(2), authContext.region)}</Label>
    </div>
  );
}

function RenderSection({
  disableAll,
  formikRef,
  taxes,
  idProduct,
  idOperation,
  idOperationParent,
  values,
  errors,
  setFieldValue,
  setFieldError,
  setTaxes,
}) {
  
  return taxes.map((tax, index) => {
    if (!tax.groupedQuestions.length) return null;
    return (
      <FormContainer key={`${tax.taxType}-${index}`} title={tax.taxType} collapsedAtStart>
        {
          tax.groupedQuestions.map((questions, indexQuestions) => {
            return (
              <FormSection
                key={indexQuestions}
                sectionIndex={indexQuestions}
                sectionName="TAX_CALCULATION"
                formikRef={formikRef}
                disableAll={disableAll}
                values={values}
                errors={errors}
                setFieldValue={setFieldValue}
                setFieldError={setFieldError}
                questionnaire={questions}
                setQuestionnaire={
                  (questionnaire) => setTaxes(taxes.map((tax, taxIndex) => taxIndex === index ? { ...tax, groupedQuestions: tax.groupedQuestions.map((v, i) => i === indexQuestions ? questionnaire : v)} : tax))
                }
                idOperation={idOperation}
                idOperationParent={idOperationParent}
                idProduct={idProduct}
                onQuestionChange={
                  (
                    question,
                    value,
                    setFieldValue,
                    questionnaireUpdated
                  ) => 
                    TaxCalculationSection.events.handleQuestionChange({
                      question,
                      value,
                      questionnaireUpdated,
                      setFieldValue,
                      tax,
                      indexQuestions,
                      setTaxes,
                    })
                }
                onBlur={
                  (
                    question, 
                    value,
                    setFieldValue, 
                    questionnaireUpdated
                  ) => 
                    TaxCalculationSection.events.handleQuestionBlur({
                      question,
                      value,
                      questionnaireUpdated,
                      setFieldValue,
                      tax,
                      indexQuestions,
                      setTaxes,
                    })
                }
              />
            )
          })
        }
        <TaxTotals tax={tax} />
      </FormContainer>
  )});
}

export const components = { RenderSection };
